import React from 'react';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';

export default function Toast({ toasts }) {
  const icons = {
    success: <CheckCircle size={18} className="text-green-500" />,
    error: <AlertCircle size={18} className="text-red-500" />,
    info: <Info size={18} className="text-blue-500" />,
  };

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div
          key={t.id}
          data-testid="toast-message"
          className="glass rounded-2xl px-5 py-3 flex items-center gap-3 shadow-xl animate-slide-up min-w-[280px]"
        >
          {icons[t.type] || icons.info}
          <span className="text-sm font-medium" style={{ color: 'var(--text-primary)' }}>{t.message}</span>
        </div>
      ))}
    </div>
  );
}
